const bussinessReviews = {
    create: () => 'create/offer',
    getById: (id) => `getOfferById/${id}`,
    listDetail: (id) => `getBusinessReviewStats`,
    ratingDetail: (id) => `star/ratingDetails/merchant/${id}`,
    reviewTagBar: (id) => `reviewTagBarChartData/${id}`,
    getLocation:(id)=> `allLocations/${id}`
}
export default bussinessReviews
